import { registerComponent } from "helpers";
import { WYATTElement } from "wyatt";

registerComponent(
  "toggle-class-button",
  class ToggleClassButton extends WYATTElement {
    constructor() {
      super();

      this.button = this.querySelector("button, a");

      this.button.addEventListener("click", this.handleClick.bind(this));
    }

    handleClick(event) {
      event.preventDefault();

      this.updateClasses();

      if (this.config.focusElement) {
        this.focus();
      }
    }

    updateClasses() {
      const targetElements = document.querySelectorAll(this.config.target);
      const classNames = this.config.classNames.split(" ");

      targetElements.forEach((element) => {
        classNames.forEach((className) => {
          element.classList.toggle(className);
        });
      });
    }

    focus() {
      const focusElement = document.querySelector(this.config.focusElement);

      if (focusElement) {
        const focusEvent = new Event("focus");

        focusElement.dispatchEvent(focusEvent);
        focusElement.focus();
      }
    }
  },
);
